import {
  isInventoryFilterColor,
  isNotInventoryFilterColor,
} from './is-inventory-filter-color';

/**
 * Extract specific filter colors from the list.
 *
 * @param filter Filter values
 * @param withColorSwatches Flag for whether to filter for colors with color swatches.
 * @returns Filtered list of colors.
 */
export default function getInventoryFilterColors(
  filter: string[],
  withColorSwatches = true
): string[] {
  return withColorSwatches
    ? filter.filter(isInventoryFilterColor)
    : filter.filter(isNotInventoryFilterColor);
}
